export default "__VITE_ASSET__cGy8cCDO__"